import React from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import StyledEditorMenuButtonItalic
  from 'components/atoms/Editors/EditorMenuButtonItalic/EditorMenuButtonItalic.styles';

const EditorMenuButtonItalic = React.forwardRef((props, ref) => {
  const innerProps = useComponentProps(props, 'EditorMenuButtonItalic');

  return <StyledEditorMenuButtonItalic buttonRef={ref} {...innerProps} />
});

EditorMenuButtonItalic.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ])
};

export default EditorMenuButtonItalic;
